import { Scalars } from '@app/graphql/service/schema'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SessionState } from './types'

const INITIAL_STATE: SessionState = {
  status: 'initial',
  sessionId: null,
  error: ''
}

export const slice = createSlice({
  name: 'session',
  initialState: INITIAL_STATE,

  reducers: {
    setSessionId: (state, action: PayloadAction<Scalars['UUID']>) => {
      state.sessionId = action.payload
    },
    requestFetchInitSession: state => {
      state.status = 'pending'
    },
    successFetchInitSession: (state, action: PayloadAction<Scalars['UUID']>) => {
      state.status = 'success'
      state.sessionId = action.payload
    },
    errorFetchInitSession: (state, action: PayloadAction<string>) => {
      state.status = 'failure'
      state.error = action.payload
    }
  }
})

export const { actions } = slice

export const sessionReducer = slice.reducer
